export const getVariantColors = (
  variant: "default" | "instructor" | "eventType" | "clearAll"
) => {
  switch (variant) {
    case "instructor":
      return { color: "#b76dff" }; // Brighter purple
    case "eventType":
      return { color: "#5dffb6" }; // Brighter green
    case "clearAll":
      return { color: "#ff6b7a" }; // Brighter red
    default:
      return { color: "#5eb3ff" }; // Brighter blue
  }
};

export const colorToRgba = (color: string, opacity: number): string => {
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  if (color.startsWith("rgb(")) {
    const values = color.match(/\d+/g);
    if (values && values.length >= 3) {
      return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${opacity})`;
    }
  }

  if (color.startsWith("rgba(")) {
    const values = color.match(/[\d.]+/g);
    if (values && values.length >= 3) {
      return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${opacity})`;
    }
  }

  return color;
};

export const calculateTagColors = (
  color?: string,
  backgroundColor?: string,
  fontColor?: string,
  variant: "default" | "instructor" | "eventType" | "clearAll" = "default"
) => {
  const variantColors = getVariantColors(variant);
  const mainColor = backgroundColor || color || variantColors.color;
  const backgroundColorWithOpacity = colorToRgba(mainColor, 0.08);
  const textColor = fontColor || mainColor;
  const borderColor = colorToRgba(mainColor, 0.5);

  return {
    backgroundColor: backgroundColorWithOpacity,
    color: textColor,
    border: `1px solid ${borderColor}`,
  };
};
